// extracted by mini-css-extract-plugin
export default {"contentWrapper":"CopyWrapper_contentWrapper__j6t7G","dropdownOverlayWrapper":"CopyWrapper_dropdownOverlayWrapper__k-0xJ","active":"CopyWrapper_active__MhaYP"};